export default __webpack_public_path__ + "static/media/ZZC_7810.54db8ade.jpg";